import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

export const campMsdReorder: FaireAdCampaignEntity = {
  token: "camp_msd_reorder",
  type: "adCampaign",
  advertiserProfileToken: "adv_michelle_starbuck",
  segment: "REORDER_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 500,
  startedRunningAt: "2026-09-01",
  segmentMetrics: {
    numReorderConversions: 9,
    salesDollars: 3412,
    totalAdsSpendDollars: 559,
    returnOnAdSpend: 6.1,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-27T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
